import { render, staticRenderFns } from "./ServidorInfoDisplay.vue?vue&type=template&id=039cbe63&scoped=true"
import script from "./ServidorInfoDisplay.vue?vue&type=script&lang=js"
export * from "./ServidorInfoDisplay.vue?vue&type=script&lang=js"
import style0 from "./ServidorInfoDisplay.vue?vue&type=style&index=0&id=039cbe63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039cbe63",
  null
  
)

export default component.exports